module.exports = __webpack_public_path__ + "static/media/16.2.5ed696a1.png";